import React from "react"

import {
    Button,
    Chip, IconButton,
    Typography,
} from "@mui/material"

import {
    t,
    Trans,
} from "@lingui/macro"
import { getChipProps } from "components/commons/contract-chip-props"
import { mdiDelete } from "@mdi/js";
import Icon from "@mdi/react";
import { DateTime } from "luxon";


export interface ContractTableInterface {
    openModal: (contractId: string) => void
    deleteContract: (contractId: string) => void
}

const defaultColumnDefinition: any = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getContractTableColumns = (component: ContractTableInterface): any => {
    return [
        {
            ...defaultColumnDefinition,
            field: "contractNumber",
            headerName: t({
                id: "ctc-contract-ident",
                message: "Identificativo",
            }),
            flex: 3,
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "status",
            headerName: t({
                id: "ctc-status",
                message: "Stato"
            }),
            flex: 2,
            renderCell: (params: any) => {
                return <Chip {...getChipProps(params.row.status)} />
            },
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "brand",
            headerName: t({
                id: "ctc-brand",
                message: "Brand",
            }),
            flex: 2,
            sortable: false
        },
        {
            ...defaultColumnDefinition,
            field: "asset",
            headerName: t({
                id: "ctc-asset",
                message: "Immobile"
            }),
            flex: 4,
            sortable: false,
        },
        {
            ...defaultColumnDefinition,
            field: "startDate",
            headerName: t({
                id: "ctc-start-date",
                message: "Data inizio"
            }),
            flex: 2,
            sortable: true,
            renderCell: (params: any) => {
                let date: string = params.row.startDate

                if (date) {
                    return (
                        <Typography>
                            {DateTime.fromISO(date).toFormat("dd MMM yyyy")}
                        </Typography>
                    )
                }
            },
        },
        {
            ...defaultColumnDefinition,
            field: "button",
            flex: 2,
            sortable: false,
            renderCell: (params: { row: any }) => (
                <>
                    <Button
                        variant="contained"
                        size="small"
                        disableElevation
                        sx={{
                            textTransform: 'none',
                            backgroundColor: 'secondary.main',
                            color: 'white',
                        }}
                        onClick={() => (component.openModal(params.row.id))}
                    >
                        <Typography>
                            <Trans id="contract-table.view-details">
                                Vedi dettagli
                            </Trans>
                        </Typography>
                    </Button>
                    <IconButton onClick={() => (component.deleteContract(params.row.id))}>
                        <Icon path={mdiDelete} size={1} />
                    </IconButton>
                </>


            ),
        },
    ]
}

export default getContractTableColumns
